class SelectKeyConditionDisplayLabels {
  constructor() {
    if (this.constructor === SelectKeyConditionDisplayLabels) {
      throw new Error("Abstract classes can't be instantiated.");
    }
  }
  getHeading() {
    throw new Error("Implement get heading function in derived classes");
  }
  getInputFieldHeading() {
    throw new Error("Implement get input field function function in derived classes");
  }
  getConfirmationText() {
    throw new Error("Implement get confirmationt ext in derived classes");
  }
  getConfirmationButtonText() {
    throw new Error("Implement get confirmation button text in derived classes");
  }
  getNextStateDisplayLabels() {
    throw new Error("Implement get next state display labels in derived classes");
  }
  getStepLabel() {
    throw new Error("Implement get step label in derived classes");
  }
}
class AddActionOfSelectKeyCondition extends SelectKeyConditionDisplayLabels {
  getConfirmationButtonText() {
    return "Preview and add conditions";
  }
  getInputFieldHeading() {
    return "Select conditions to identify member(s)";
  }
  getConfirmationText() {
    return "Add conditions as rule. This will automatically add profiles with the selected conditions.";
  }
  getNextStateDisplayLabels() {
    return new AddActionOfPreviewKeyCondition();
  }
}
export class AddByKeyConditionDisplayLabel extends AddActionOfSelectKeyCondition {
  getHeading() {
    return "Add members by key condition";
  }
}

export class AddActionOfKeyCondition extends AddActionOfSelectKeyCondition {
  getHeading() {
    return "";
  }

  getInputFieldHeading() {
    return "";
  }

  getStepLabel() {
    return "Select conditions"
  }
}

export class AddActionOfIndividualnclusion extends AddActionOfSelectKeyCondition {
  isIndividualInclusionNamingEnabled = false;

  constructor(isIndividualInclusionNamingEnabled) {
    super()
    this.isIndividualInclusionNamingEnabled = isIndividualInclusionNamingEnabled
  }

  getHeading() {
    return "";
  }

  getInputFieldHeading() {
    return "";
  }

  getConfirmationText() {
    return this.isIndividualInclusionNamingEnabled
      ? "Add selected user as an individual inclusion"
      : "Add selected user as a special member";
  }

  getConfirmationButtonText() {
    return "Preview and add user";
  }

  getStepLabel() {
    return "Select member";
  }
}

export class SearchByUsersDisplayLabel extends AddActionOfSelectKeyCondition {
  getHeading() {
    return "Add members";
  }
}

export class EditActionOfSelectKeyCondition extends SelectKeyConditionDisplayLabels {
  getConfirmationButtonText() {
    return "Preview and update conditions";
  }
  getInputFieldHeading() {
    return "Edit conditions";
  }
  getConfirmationText(isSpecialCondition) {
    if (isSpecialCondition) {
      return "Update special condition.";
    } else {
      return "Update key condition. This will automatically add people who matches the conditions.";
    }
  }
  getHeading(isSpecialCondition) {
    function specialOrKeyCondition() {
      return isSpecialCondition ? "special" : "key";
    }
    return `Edit ${specialOrKeyCondition()} condition`;
  }
  getNextStateDisplayLabels() {
    return new EditActionOfPreviewKeyCondition();
  }
}

export class EditActionOfSelectCondition extends SelectKeyConditionDisplayLabels {
  getConfirmationButtonText() {
    return "Preview and update conditions";
  }
  getConfirmationText() {
    return "Update key condition. This will automatically add people who matches the conditions.";
  }
  getHeading() {
    return `Edit key condition`;
  }
  getNextStateDisplayLabels() {
    return new EditActionOfPreviewKeyCondition();
  }
  getStepLabel() {
    return "Edit conditions";
  }
}

export class EditActionOfIndividualInclusion extends SelectKeyConditionDisplayLabels {
  isIndividualInclusionNamingEnabled = false;

  constructor(isIndividualInclusionNamingEnabled) {
    super();
    this.isIndividualInclusionNamingEnabled = isIndividualInclusionNamingEnabled;
  }

  getConfirmationButtonText() {
    return "Update";
  }
  getStepLabel() {
    return this.isIndividualInclusionNamingEnabled
      ? "Edit individual inclusion"
      : "Edit special member's details";
  }
  getConfirmationText() {
    return this.isIndividualInclusionNamingEnabled
      ? "Update individual inclusion"
      : "Update special member's details";
  }
  getHeading() {
    return this.isIndividualInclusionNamingEnabled
      ? `Edit individual inclusion`
      : `Edit special member's details`;
  }
  getNextStateDisplayLabels() {
    return new EditActionOfPreviewKeyCondition();
  }
}

class PreviewKeyConditionDisplayLabels {
  constructor() {
    if (this.constructor === PreviewKeyConditionDisplayLabels) {
      throw new Error("Abstract classes can't be instantiated.");
    }
  }
  getConfirmationText() {
    throw new Error("Implement get confirmationt ext in derived classes");
  }
  getConfirmationButtonText() {
    throw new Error("Implement get confirmation button text in derived classes");
  }
}

export class AddActionOfPreviewKeyCondition extends PreviewKeyConditionDisplayLabels {
  getConfirmationText() {
    return "Add conditions as rule. This will automatically add profiles with the selected conditions.";
  }
}

export class EditActionOfPreviewKeyCondition extends PreviewKeyConditionDisplayLabels {
  getConfirmationText(isSpecialCondition) {
    if (isSpecialCondition) {
      return "Update special condition.";
    } else {
      return "Update key condition. This will automatically add people who matches the conditions.";
    }
  }
}

export class DeleteActionOfPreviewKeyCondition extends PreviewKeyConditionDisplayLabels {
  getConfirmationText() {
    return "Delete condition. This will automatically delete existing members that match the condition.";
  }
}
